module.exports = __webpack_public_path__ + "img/Business-text.564c2cfd.jpg";